import { mapGetters } from 'vuex'
import HipotekaMap from './../components/hipoteka/hipotekaMap'

export default {
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(['hipotekaReadonly', 'hipotekaBusena']),
    rengiamas() {
      return HipotekaMap['objektasBusena'].rengiamas.key
    },
    patvirtinti() {
      return HipotekaMap['objektasBusena'].patvirtinti.key
    },
    laukiaPatvirtinimo() {
      return HipotekaMap['objektasBusena'].laukia_patvirtinimo.key
    },
    laukiaApmokejimo() {
      return HipotekaMap['objektasBusena'].laukia_apmokejimo.key
    },
    perduotas() {
      return HipotekaMap['objektasBusena'].perduotas.key
    },
    grazintas() {
      return HipotekaMap['objektasBusena'].grazintas.key
    },
    nepatikslintas() {
      return HipotekaMap['objektasBusena'].nepatikslintas.key
    },
    iregistruotas() {
      return HipotekaMap['objektasBusena'].iregistruotas.key
    },
    atmestas() {
      return HipotekaMap['objektasBusena'].atmestas.key
    },
    isRengiamas() {
      return this.hipotekaBusena === this.rengiamas
    },
    isPatvirtinti() {
      return this.hipotekaBusena === this.patvirtinti
    },
    isLaukiaPatvirtinimo() {
      return this.hipotekaBusena === this.laukiaPatvirtinimo
    },
    isLaukiaApmokejimo() {
      return this.hipotekaBusena === this.laukiaApmokejimo
    },
    isPerduotas() {
      return this.hipotekaBusena === this.perduotas
    },
    isGrazintas() {
      return this.hipotekaBusena === this.grazintas
    },
    isNepatikslintas() {
      return this.hipotekaBusena === this.nepatikslintas
    },
    isIregistruotas() {
      return this.hipotekaBusena === this.iregistruotas
    },
    isAtmestas() {
      return this.hipotekaBusena === this.atmestas
    },
    isReadonly() {
      return this.hipotekaReadonly
    },
  },
  methods: {
    //
  },
}
